import { Stack, styled } from "@mui/material";

export const Wrapper = styled(Stack, {
    shouldForwardProp: (prop) => prop !== "verticalCenter" && prop !== "hasBackgroundImage",
})<{ verticalCenter?: boolean; hasBackgroundImage?: boolean }>(({ verticalCenter, hasBackgroundImage }) => ({
    position: hasBackgroundImage ? "relative" : undefined,
    justifyContent: verticalCenter ? "center" : "flex-start",
    alignSelf: verticalCenter ? "stretch" : "flex-start",
    width: "100%",
    maxWidth: "962px",
    marginLeft: "auto",
    marginRight: "auto",
}));
